import React from 'react'

const Legal = () => {
  return (
    <div className='legal'>
      <p className='legal-text'>© 2024 Path CCM, Inc. d/b/a Rula Health.  All rights reserved.</p>
      <div className='legal-links'>
        <a href='/privacy-policy'>Privacy Policy</a>
        <a href='/privacy-notice-for-california-residents'>California Privacy Notice</a>
        <a href='/privacy-practices'>Notice of Privacy Practice</a>
        <a href='/billing-rights'>No Surprises Act</a>
        <a href='/terms-of-use'>Terms of Use</a>
        <a href='/patient-rights'>Patient Rights</a>
        <a href='https://web.fountain.com/path/apply'>Provider Positions</a>
      </div>
    </div>
  )
}

export default Legal
